export default __webpack_public_path__ + "static/media/masha.2bc263f1.jpg";